import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = [ "body", "form" ]

    toggle() {
        this.bodyTarget.classList.add("d-none")
        this.formTarget.classList.remove("d-none")
    }
}